import React from "react";
import "./LoadingSpinner.css";

export default function LoadingSpinner() {
  return (
    <div className="loading-screen">
      <div className="loading-spinner"></div>
    </div>
  );
}